import tw, { styled } from 'twin.macro';

const BaseImageContainer = styled.div`
  ${tw`flex`}
  ${tw`col-start-1 col-end-13`}

  & img {
    ${tw`!object-contain`}
  }
`;

export const StyledImageContainer = styled(BaseImageContainer)<{
  isReversed: boolean;
}>`
  ${tw`mt-5 md:mx-auto lg:mt-0`}
  ${tw`md:max-h-[500px]`}
  ${tw`rounded-lg overflow-hidden`}
  ${({ isReversed }) =>
    isReversed
      ? tw`lg:col-start-1 lg:col-end-7 lg:order-1`
      : tw`lg:col-start-7 lg:col-end-13 lg:order-2`}
`;

export const StyledShadowcastImageContainer = styled(BaseImageContainer)`
  ${tw`relative`}
  ${tw`mb-9 ml-5 md:mx-auto md:mb-0 `}
  ${tw`rounded-2xl`}
  ${tw`bg-neutrals-n1`}
  ${tw`shadow-[0_4px_8px_4px_rgba(18,110,211,0.15)]`}

  // Image size = 128px = 176px container - (22px padding + 2px border) * 2 sides
  ${tw`w-[176px] h-[176px]`}
  ${tw`p-[22px]`}
  ${tw`border-2 border-secondary-s1`}

  // Style the shadowcast background
  ${tw`after:content-[''] after:rounded-2xl after:bg-ui-colours-ui3`}
  ${tw`after:w-[176px] after:h-[176px]`}
  ${tw`after:absolute after:-left-[44px] after:top-[36px] after:-z-10`}

  // Positioning for reversed layout by default
  ${tw`md:col-start-1 md:col-end-5 lg:col-start-1 lg:col-end-4 order-1`}
`;
